"use strict";

var _defineProperty2 = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CUSTOM_PROPERTY_NAME = '--aspect-ratio';

var AspectRatio =
/*#__PURE__*/
function (_react$Component) {
  _inherits(AspectRatio, _react$Component);

  function AspectRatio() {
    var _this;

    _classCallCheck(this, AspectRatio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AspectRatio).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "setNode", function (node) {
      _this.node = node;
    });

    return _this;
  }

  _createClass(AspectRatio, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.node) {
        var node = this.node; // BC for older version of React https://github.com/facebook/react/issues/6411
        // check if React support custom property AFTER

        var customPropertyValue = node.style.getPropertyValue(CUSTOM_PROPERTY_NAME);

        if (!customPropertyValue) {
          node.style.setProperty(CUSTOM_PROPERTY_NAME, "(" + this.props.ratio + ")");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ratio = _this$props.ratio,
          style = _this$props.style,
          children = _this$props.children,
          otherProps = _objectWithoutPropertiesLoose(_this$props, ["ratio", "style", "children"]); // eslint-disable-line no-unused-vars


      var newStyle = _extends({}, style, _defineProperty2({}, CUSTOM_PROPERTY_NAME, "(" + ratio + ")"));

      return _react["default"].createElement("div", _extends({
        ref: this.setNode,
        style: newStyle
      }, otherProps), children);
    }
  }]);

  return AspectRatio;
}(_react.Component);

_defineProperty(AspectRatio, "defaultProps", {
  className: 'react-aspect-ratio-placeholder',
  ratio: 1
});

var _default = AspectRatio;
exports["default"] = _default;